import React, { useContext, useEffect } from 'react';
import { useRoutes, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { AppContext } from '../../Context';
import DashboardView from '../../routes/dashboardView';
import { SignOutView } from '../../routes/SignOutView';
import { CuadernoDigital } from '../../routes/CuadernoDigital';
import { MaterialTeorico } from '../../routes/MaterialTeorico';
import { MaterialDidactico } from '../../routes/MaterialDidactico';
import { ChooseUsernameView } from '../../routes/ChooseUsernameView';
import { EditProfileView } from '../../routes/editProfileView';
import { MasterView } from '../../routes/MasterView';
import { RegistroDePracticas } from '../../routes/RegistroDePracticas';
import { ListadoAlumnos } from '../../routes/ListadoAlumnos';
import { DetalleAlumno } from '../../routes/DetalleAlumno';
import { AddMaterialDidactico } from '../../routes/Components/AddMaterialDidactico';
import { AddMaterialTeorico } from '../../routes/Components/MaterialTeorico/AddMaterialTeorico';
import { AddCuadernoDigital } from '../../routes/Components/AddCuadernoDigital';
import { ViewMaterialTeorico } from '../../routes/ViewMaterialTeorico';
import { DetalleMaterialTeorico } from '../../routes/DetalleMaterialTeorico';
import { Evaluacion2 } from '../../components/evaluaciones/Evaluacion2';
import { DetalleEvaluacion } from '../../routes/DetalleEvaluacion';
import EvaluacionBasica from '../../routes/EvaluacionBasica';
import EvaluacionIntermedia from '../../routes/EvaluacionIntermedia';
import EvaluacionAvanzada from '../../routes/EvaluacionAvanzada';
import AlumnoForm from '../../routes/DetailsStudent/AlumnoForm';
import EstatusModal from '../../routes/DetailsStudent/EstatusModal';
import FichasTable from '../../routes/DetailsStudent/FichasTable';
import RegistroPracticas from '../../routes/DetailsStudent/RegistroPracticas';
import RegistroDePracticasDetalle from '../../routes/RegistroDePracticasDetalle';
import SesionesAlumno from '../../routes/DetailsStudent/SesionesAlumno';
import EstimulacionNeuronal from '../../routes/Components/EstimulacionNeuronal';
import { AddLecturasAdicionales } from '../../routes/Components/LecturasAdicionales/AddLecturasAdicionales';
import LecturasAlumno from '../../routes/DetailsStudent/LecturasAlumno';
import { ViewLecturasAlumnos } from '../../routes/Components/LecturasAdicionales/View/ViewLecturasAlumnos';
import { DetalleLecturasAlumnos } from '../../routes/Components/LecturasAdicionales/View/DetalleLecturasAlumnos';
import LecturasTable from '../../routes/Components/LecturasAdicionales/LecturasTable';
import GroupChatView from '../../routes/Components/GroupChatView';
import ChatView from '../../routes/Components/ChatView';
import SesionAlumno from '../../routes/Components/SesionAlumno';
import PracticasAlumno from '../../routes/PracticasAlumno';
import NotFoundView from '../../routes/NotFoundView';
import NotificationsAll from '../../routes/NotificationsAll';
import PracticalReadingPendingAccess from '../../routes/PracticalReadingPendingAccess';
import RegistroLog from '../../routes/RegistroLog';

const RequireRole = ({ allowed, children }) => (
  allowed ? children : <Navigate to="/dashboard" replace />
);

const AppRoutes = () => {
  const { currentUser, justLoggedIn, setJustLoggedIn } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const isMaster = currentUser?.isMaster === true;
  const isTeacher = currentUser?.teacher === true;
  const isStudent = !isMaster && !isTeacher;
  const canManageStudents = isMaster || isTeacher;

  useEffect(() => {
    if (justLoggedIn) {
      setJustLoggedIn(false);

      if (location.pathname !== '/dashboard') {
        navigate('/dashboard', { replace: true });
      }
    }
  }, [justLoggedIn, setJustLoggedIn, navigate, location.pathname]);

  const routes = useRoutes([
    { path: '/', element: <Navigate to="/dashboard" replace /> },
    { path: '/login', element: <Navigate to="/dashboard" replace /> },
    { path: '/master', element: <RequireRole allowed={isMaster}><MasterView /></RequireRole> },
    { path: '/registro-log', element: <RequireRole allowed={isMaster}><RegistroLog /></RequireRole> },
    { path: '/dashboard', element: <DashboardView /> },
    { path: '/material-didactico', element: <MaterialDidactico /> },
    { path: '/material-teorico', element: <MaterialTeorico /> },
    { path: '/cuaderno-digital', element: <CuadernoDigital /> },
    { path: '/dashboard/profile', element: <EditProfileView /> },
    { path: '/signout', element: <SignOutView /> },
    { path: '/choose.username', element: <ChooseUsernameView /> },
    { path: '/listado-alumnos', element: <RequireRole allowed={canManageStudents}><ListadoAlumnos /></RequireRole> },
    { path: 'dashboard/listado-alumnos/detalle-alumno/:id', element: <RequireRole allowed={canManageStudents}><DetalleAlumno /></RequireRole> },
    { path: 'dashboard/listado-alumnos/registro-de-practicas/:id', element: <RequireRole allowed={canManageStudents}><RegistroDePracticas /></RequireRole> },
    { path: 'dashboard/listado-alumnos/registro-de-practicas/:id/ejercicio', element: <RequireRole allowed={canManageStudents}><RegistroDePracticasDetalle /></RequireRole> },
    { path: 'dashboard/master/agregar-material-didactico', element: <RequireRole allowed={isMaster}><AddMaterialDidactico /></RequireRole> },
    { path: 'dashboard/master/agregar-material-teorico', element: <RequireRole allowed={isMaster}><AddMaterialTeorico /></RequireRole> },
    { path: 'dashboard/master/agregar-cuaderno-digital', element: <RequireRole allowed={isMaster}><AddCuadernoDigital /></RequireRole> },
    { path: 'dashboard/master/ver-material-teorico/:id', element: <RequireRole allowed={isMaster}><ViewMaterialTeorico /></RequireRole> },
    { path: 'dashboard/material-teorico', element: <MaterialTeorico /> },
    { path: 'dashboard/material-teorico/detalle/:nivel', element: <DetalleMaterialTeorico /> },
    { path: '/evaluacion2', element: <Evaluacion2 /> },
    { path: '/evaluacion/:id', element: <DetalleEvaluacion /> },
    { path: '/evaluacion-basica', element: <EvaluacionBasica /> },
    { path: '/evaluacion-intermedia', element: <EvaluacionIntermedia /> },
    { path: '/evaluacion-avanzada', element: <EvaluacionAvanzada /> },
    { path: '/AlumnoForm', element: <AlumnoForm /> },
    { path: '/EstatusModal', element: <EstatusModal /> },
    { path: '/FichasTable', element: <FichasTable /> },
    { path: '/RegistroPractica', element: <RegistroPracticas /> },
    { path: '/SesionesAlumno', element: <SesionesAlumno /> },
    { path: '/EstimulacionNeuronal', element: <RequireRole allowed={isStudent}><EstimulacionNeuronal /></RequireRole> },
    { path: 'dashboard/master/agregar-lecturas-adicionales', element: <RequireRole allowed={isMaster}><AddLecturasAdicionales /></RequireRole> },
    { path: '/LecturasAdicionales', element: <LecturasAlumno /> },
    { path: 'dashboard/lecturas-adicionales/detalle/:nivel', element: <DetalleLecturasAlumnos /> },
    { path: '/ViewLecturasAlumnos', element: <ViewLecturasAlumnos /> },
    { path: '/LecturasTable', element: <LecturasTable /> },
    { path: '/group-chat', element: <GroupChatView /> },
    { path: '/chat', element: <ChatView /> },
    { path: '/sesion-alumno', element: <SesionAlumno /> },
    { path: '/practicas-alumno', element: <PracticasAlumno /> },
    { path: '/dashboard/notificaciones', element: <RequireRole allowed={canManageStudents}><NotificationsAll /></RequireRole> },
    { path: '/dashboard/master/pendientes-ejercicios-practicos', element: <RequireRole allowed={isMaster}><PracticalReadingPendingAccess /></RequireRole> },
    { path: '/404', element: <NotFoundView /> },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);

  return routes;
};

export { AppRoutes };
